import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const MediaContext = createContext();

export const MediaProvider = ({ children }) => {
  const [fsImages, setFsImages] = useState([]);
  const [fzImages, setFzImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const MEDIA_API_URL = `https://admin.thirsty-shtern.91-151-16-181.plesk.page/files`;

  useEffect(() => {
    const ac = new AbortController();
    const fetchMedia = async () => {
      setLoading(true); setError(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(MEDIA_API_URL, {
            params: { fields: "id,title,filename_disk,tags", limit: 100 },
            signal: ac.signal
          }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        const list = res?.data?.data ?? [];
        setFsImages(list.filter(img => img.tags?.includes("fs")));
        setFzImages(list.filter(img => img.tags?.includes("fz")));
      } catch (e) {
        if (!ac.signal.aborted) setError("Fehler beim Laden der Mediendateien.");
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    };
    fetchMedia();
    /* return () => ac.abort(); */
  }, []);

  return (
    <MediaContext.Provider value={{ fsImages, fzImages, loading, error }}>
      {children}
    </MediaContext.Provider>
  );
};
